import { Component, OnInit,ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as PageStore from "src/app/Store/PageStore/Page.Actions";
import { UserSettings } from '../model/UserSettings';
import { APICallingService } from '../model/APICallingService';
import { Router } from '@angular/router';
// import * as AppSettings from '../Store/Appsettings/AppSettings';
import { HttpClient } from '@angular/common/http';
import { AppSettings, IAppSettings } from '../model/application-settings';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.css']
})
export class EditprofileComponent implements OnInit {
  Address:string="";
  AddressType:string="";
  AddressList:any; 
  City:string="";
  confirmpassword:string="";
  ContactNo:string="";
  Country:string="";
  currentpassword:string="";
  dbResult:any;
  ID:number=0;
 // LoginDetails:any;
  newpassword:string="";
  Zip:string="";
  State:string="";
  storeUserSettings:any;
  submit = false;
  submited = false;
  submitted = false;

  Email : string | undefined;
  Name : string| undefined;
  Message : string| undefined;
  Subject : string| undefined;

  @ViewChild('closebutton') closebutton:any;
  // https://mechknowsamplework.com/HyderabadUS/HyderabadUSAdminWebAPI/ApplicationLevelScripts/Images/
  // http://localhost/ApplicationLevelScripts/Images/


  constructor(private store: Store<any>,private apiCall:APICallingService,private http :HttpClient, private storeAppSettings:AppSettings,
    private router:Router) { }
  storeSettings:IAppSettings=
  {
    faxUserId:'',
    faxPassword:'',

    companyName:'',
      theamColorCode:'#ea0029',
      headerColorCode: '#000',
      headerimage: '../../assets/img/trending1.png',
      loginBackgroundImage:'../../assets/img/logo_web.png',
      loginImage:'../../assets/img/logo_web.png',
      dangerColorCode: '#dc3545',
      successColorCode: '#28a745',
      logo: '../../assets/img/logo_web.png',
      paymentGateway:'',
      key:'',
      selectedBranch:'',
      apiLoginId:'',
      orderEmail:'',
      adminUrl:'',
      orderUrl:'',
      viewName:'AppSettings',
      apiCallingUrl:'',
      fontFamily:'prompt,sans-serif',
      domainName:'',
      fax:'',
      projectId:'',
      keyNo:'',
      noOfBranches:0,
      addClover:'',
      cloverAccessToken:'',
      cloverAuthToken:'',
      cloverMerchantId:'',
      cloverEmployeeID:'',
      cloverTenderId:'',
      currency:'',
      transactionkey:'',
  };
  ngOnInit(): void {
    debugger;
    this.storeUserSettings= new UserSettings();
    var result = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
    if (result.length > 0) {
      this.storeUserSettings=( Object.assign({},result[0] ));
    }
    this.storeSettings= this. storeAppSettings.loadSettings();
    let storeDeliveryLocation = (this.store as any).source['value']['MSFOO'].filter((x:any) => {
      return x.viewName == 'AppSettings';
      
    });
    if( storeDeliveryLocation.length > 0) {
  
      let storeBranch=Object.assign({},  storeDeliveryLocation[0]);
  
    this.lstDeliveryLocation=Object.assign([], storeBranch.selectedBranch.lstDeliveryLocation) ;
      
    }
    // this.Name = "Hayden Pierce";
    // this.Email = "HaydenPierce@example.com";
    // this.Subject = "Test Mail";
    // this.Message = "Hello, this is Hayden.";
    this.getAddressthroughId();
    //this.getLoginDetails();
  }

  lstDeliveryLocation=[{ZipCode:'',LocationName:''}];
  validateProfile():any{
      var validate=true;
      var valEmail=this.validateEmail(this.storeUserSettings.Email);
    if((this.storeUserSettings.Email==''|| (valEmail!=true))&& validate){
    validate =false;
    }
    if(this.storeUserSettings.FirstName=='' && validate)
    {
    validate =false;
    }
    if(this.storeUserSettings.LastName=='' && validate)
    {
    validate =false;
    }
    if(this.storeUserSettings.Mobile=='' && validate)
    {
    validate =false;
    }
    var valPhone=this.validateMobile(this.storeUserSettings.Mobile);
    if((this.storeUserSettings.Mobile==''|| (valPhone!=true))&& validate)
    {
    validate =false;
    }
    return validate;
    }

    validateChangePassword(){
      var validate=true;
    if(this.currentpassword=='' && validate)
    {
    validate =false;
    }
    if(this.newpassword=='' && validate)
    {
    validate =false;
    }
    if(this.confirmpassword=='' && validate)
    {
    validate =false;
    }
    if(this.confirmpassword!='' &&this.newpassword!='' && this.currentpassword!='' &&this.newpassword == this.currentpassword   && validate)
    {
    validate =false;
    }
    if(this.currentpassword!='' &&this.currentpassword != this.storeUserSettings.Password && validate)
    {
    validate =false;
    }
    if(this.confirmpassword!='' &&this.newpassword!='' &&this.confirmpassword != this.newpassword && validate)
    {
    validate =false;
    }
    return validate;
    }

    validateAddress():any{
      var validate=true;
    if(this.Address=='' && validate)
    {
    validate =false;
    }
    if(this.AddressType=='' && validate)
    {
    validate =false;
    }
    var valPhone=this.validateMobile(this.ContactNo);
    if((this.ContactNo==''|| (valPhone!=true))&& validate)
    {
    validate =false;
    }
    if(this.City=='' && validate)
    {
    validate =false;
    }
    if(this.Zip=='' && validate)
    {
    validate =false;
    }
    return validate;
    }

    validateEmail(input:any):boolean {
    var regexp=new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    var res= regexp.test(input)
    return res;
    }

    validateMobile(input:any):boolean {
    var regexp=new RegExp(/^[6-9]\d{9}$/);
    var res= regexp.test(input)
    return res;
    }

    validtrue = false;
    changepass(){
      debugger;
      if(this.currentpassword!='' && this.currentpassword!=this.storeUserSettings.Password){
        this.validtrue = true;
      }else {
        this.validtrue = false;
      }
    }

    showaddress = false;
    chkEvent(d:any) {
      debugger;
      if (d == 1) {
        this.showaddress = true;
      } else {
        this.showaddress = false;
      }
    }

    ShowProfile(){
      this.showaddress = false;
    }

    // getLoginDetails(){
    //   debugger;
    //   this.apiCall.DBCalling("getLoginDetailsThroughId",this.storeUserSettings.UserID,"","","").subscribe(
    //     (res:any) => {
    //       debugger;
    //       this.dbResult= (res);
    //       this.LoginDetails = (Object.assign({},this.dbResult.tasks[0][0]));
    //   });
    // }

    getAddressthroughId(){
      debugger;
      this.apiCall.DBCalling("GetUserAddressByUserId",this.storeUserSettings.UserID,"","","").subscribe(
        (res:any) => {
          debugger;
          this.dbResult= (res);
          this.AddressList = (Object.assign(this.dbResult.tasks[0]));
      });
    }
    changePasswordModelClose()
    {
      this.changepasswordmodeldisplay='none';
    }

    addressModalClose(){
      this.addressmodaldisplay = 'none';
    }
    changePasswordClick(){
      this.changepasswordmodeldisplay='block';
      this.submited = false;
      this.currentpassword = '';
      this.newpassword = '';
      this.confirmpassword = '';
    }

  saveChangePassword(){
    this.submited = true;
    if(this.validateChangePassword()){
    var xml1='<NewDataSet><Table1>'
    +'<OldPassword>'+this.currentpassword+'</OldPassword>'
    +'<Password>'+this.newpassword+'</Password>'
    +'<UserID>'+this.storeUserSettings.UserID+'</UserID>'
    +'</Table1></NewDataSet>';
  debugger;
  this.apiCall.DBCalling("UpdatePassword",xml1,"","","").subscribe(
      (res:any) => {
       debugger;
       this.dbResult= (res);
       if(this.dbResult.tasks[0][0].DBresult>0)
       {
        debugger;
        this.store.dispatch(new  PageStore.OpenPage(this.storeUserSettings));
        // this.closebutton.nativeElement.click();
        this.changepasswordmodeldisplay = 'none';
        //alert('Password Updated Successfully');
        Swal.fire({
          position: 'center',
          icon: 'success',
          text:'Password Updated Successfully'
        });
        let storeUserSettings=new UserSettings;
        this.storeUserSettings.viewName="UserDetails";
        this.store.dispatch(new  PageStore.OpenPage(storeUserSettings));
        this.router.navigateByUrl('/login');
        }else{
          // this.closebutton.nativeElement.click();
          this.changepasswordmodeldisplay = 'none';
          //alert("failed.! Contact System Admin");  
          Swal.fire({
            position: 'center',
            icon: 'error',
            text:'failed.! Contact System Admin'
          });
        }
        });
      }
  }
  homeClick()
  {
    this.router.navigateByUrl('/')
  }
  saveProfile(){
    debugger;
    this.submit = true;
    if(this.validateProfile()){
      var xml1='<NewDataSet><Table1>'
      +'<FirstName>'+this.storeUserSettings.FirstName+'</FirstName>'
      +'<Email>'+this.storeUserSettings.Email+'</Email>'
      +'<LastName>'+this.storeUserSettings.LastName+'</LastName>'
      +'<Mobile>'+this.storeUserSettings.Mobile+'</Mobile>'
      +'<ProfileImage>'+this.storeUserSettings.ProfileImage+'</ProfileImage>'
      +'<UserID>'+this.storeUserSettings.UserID+'</UserID>'
      +'</Table1></NewDataSet>';
    debugger;
    this.apiCall.DBCalling("UpdateProfile",xml1,"","","").subscribe(
        (res:any) => {
         debugger;
         this.dbResult= (res);
         if(this.dbResult.tasks[0][0].DBresult>0)
         {
          debugger;
          this.store.dispatch(new  PageStore.OpenPage(this.storeUserSettings));
         // alert('Profile Updated Successfully');
         Swal.fire({
          position: 'center',
          icon: 'success',
          text:'Profile Updated Successfully'
        });
          }else{
           // alert("Something Went Wrong!");  
           Swal.fire({
            position: 'center',
            icon: 'error',
            text:'Something Went Wrong!'
          });
          }
          });
      }
    }

    saveAddress(){
      this.submitted= true;
      if(this.validateAddress()){
        var xml1='<NewDataSet><Table1>'
        +'<ID>'+this.ID+'</ID>'
        +'<Address>'+this.Address+'</Address>'
        +'<AddressType>'+this.AddressType+'</AddressType>'
        +'<ContactNo>'+this.ContactNo+'</ContactNo>'
        +'<City>'+this.City+'</City>'
        +'<Zip>'+this.Zip+'</Zip>'
        +'<UserID>'+this.storeUserSettings.UserID+'</UserID>'
        +'</Table1></NewDataSet>';
      debugger;
      this.apiCall.DBCalling("SaveUserAddress",this.storeUserSettings.UserID,xml1,"","").subscribe(
          (res:any) => {
           debugger;
           this.dbResult= (res);
           if(this.dbResult.tasks[0][0].DBresult>0 && this.dbResult.tasks[0][0].ID > 0)
           {
            debugger;
            // this.closebutton.nativeElement.click();
            this.addressmodaldisplay = 'none';
            this.getAddressthroughId();
            // alert('Address Saved Successfully');
            Swal.fire({
              position: 'center',
              icon: 'success',
              text:'Address Saved Successfully'
            });
            }else if(this.dbResult.tasks[0][0].DBresult>0){
              // this.closebutton.nativeElement.click();
              this.addressmodaldisplay = 'none';
              this.getAddressthroughId();
              // alert("Address Updated Successfully");  
              Swal.fire({
                position: 'center',
                icon: 'success',
                text:'Address Updated Successfully'
              });
            }
            else{
              this.closebutton.nativeElement.click();
              // alert('Something Went Wrong!');
              Swal.fire({
                position: 'center',
                icon: 'error',
                text:'Something Went Wrong!'
              });
            }
            });
      }
    }

    setLocation(val:any)
    {
      debugger;
      this.Zip=val.target.value
      this.City=((this.lstDeliveryLocation as any).filter((x: any) => (x as any).ZipCode==val.target.value))[0].LocationName;
    }

    addressTypeClick(type:any)
    {
      this.AddressType=type;
    }

    changepasswordmodeldisplay='none';
    addressmodaldisplay = 'none';
    addAddress(data:any){
      debugger;
      this.ID = data.ID;
      this.addressmodaldisplay = 'block';
      this.submitted = false;
      this.Address = data.Address;
      this.AddressType = data.AddressType;
      this.ContactNo = data.ContactNo;
      // this.Country = '';
      // this.State = '';
      this.City = data.City;
      this.Zip = data.Zip;
    }

    editAddress(e:any){
      debugger;
      this.addressmodaldisplay = 'block';
      this.ID = e.ID;
      this.Address = e.Address;
      this.AddressType = e.AddressType;
      this.ContactNo = e.ContactNo;
      this.Country = e.Country;
      this.State = e.State;
      this.City = e.City;
      this.Zip = e.Zip;
    }

    deleteAddressAlert(e:any){
      debugger;
     try {
        debugger;
        Swal.fire({
          title: 'Are you sure',
          text: 'Do you want to delete',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then((result) => {
          if (result.value) {
            debugger;
            this.deleteAddress(e);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire(
              'Cancelled',
              'your record is safe',
              'error'
            )};
        });
      }
    catch (e) { }
    }

    deleteAddress(e:any){
      debugger;
      let Xml1:string;
        Xml1 = "<NewDataSet><Table1>"
        +'<ID>'+ e.ID +'</ID>'
        +'</Table1></NewDataSet>'
        this.apiCall.DBCalling("DeleteUserAddress", Xml1, "null", "null", "null").subscribe((data: any) => {
          debugger;
          this.dbResult= (data);
          if(this.dbResult.tasks[0][0].DBresult>0){
            // alert('Adress deleted successfully');
            Swal.fire({
              position: 'center',
              icon: 'success',
              text:'Adress deleted successfully'
            });
            this.getAddressthroughId();
          }
        });
    }
    
    selectedFile: ImageSnippet| undefined;
    formData: FormData| undefined;
    DocName = "";
    imgURL: any;
    ImagefileChange($event:any, ControlName:any) {
      debugger;
       if (this.storeUserSettings.FirstName != '') {
        var file: File = $event.target.files[0];
        // this.imgURL.setValue(file);
        this.storeUserSettings.ProfileImage = file.name;
        var fileType = file.type;
        var extention = this.storeUserSettings.ProfileImage.split('.').pop();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (_event) => {
          debugger;
          try{
          var path:any = reader.result;
          this.selectedFile = new ImageSnippet(path.toString(), file);
          debugger;
          this.imgURL = reader.result;
          debugger;
           this.SaveImage();
          }
          catch(error){
          }
        }
      }
    }
    Imagesubmited = false;

    pathofImage:any;
    SaveImage() {
      debugger;
      // https://mechknowsamplework.com/HyderabadUS/HyderabadUSAdminWebAPI/ApplicationLevelScripts/upload2.php
      // http://localhost/ApplicationLevelScripts/upload2.php
     let currDatetime: string = new Date().toLocaleTimeString();
     this.http.post(this.storeSettings.apiCallingUrl+'/upload2.php', {'image':this.imgURL,  'Id': this.storeUserSettings.UserID,'DateTime':currDatetime })
    .subscribe((res:any) => {
      debugger;
      this.imgURL = "";
      this.pathofImage = res;
       var newStr = this.pathofImage[0].path.replace('Images/','');
       this.storeUserSettings.ProfileImage = newStr;
      this.saveProfile();
    })
    }

    // sendEmail(){
    //   debugger;
    //   let postVars = {
    //     Name : this.Name,
    //     Email : this.Email,
    //     Message : this.Message
    //   };
    //   debugger;
    //   var data = JSON.stringify({'Name':this.Name ,'Email':this.Email , 'Message':this.Message});
    //   this.http.post('https://mechknowsamplework.com/HyderabadUS/HyderabadUSAdminWebAPI/ApplicationLevelScripts/Email.php', {'Name':this.Name ,'Email':this.Email , 'Message':this.Message}).subscribe((res) => {
    //     debugger;
    //     console.log(res);
    //    })
    //   debugger;
    // }

}

class ImageSnippet {
  constructor(public src: string, public file: File) { }
}